import React, { useEffect, useMemo, useRef, useState } from "react";
import { ChildContainer, Container } from "../../components/Container/Containers";
import IMAGES from "../../assets/images/images";
import styles from "./regulatory.module.css";
import CustomDropdownMenu from "../../components/customDropdown/CustomDropdown";
import Shimmer from "../../components/shimmer/Shimmer";
import Asterisk from "../../components/asterisk/Asterisk";
import RegulatoryDisclaimer from "./regulatoryDisclaimer/regulatoryDisclaimer";
import {formatDate} from '../../utils/arrayUtils'
import useRestrictCopyPaste from "../../hooks/useRestrictCopyPaste";
import { Banner } from "../../components/banner/Banners";

const CountryDropdown = (props) => {
  const [selectedOption, setSelectedOption] = useState(null);
 
  const onConsentAccept=(()=>{
      props.handleConsentAccept()
  })

  const setCountry = (option) => {
    setSelectedOption(option)
    props.handleCountrySelect(option)
  }

  const dropdownOptions = useMemo(() => {
    return props?.regulatorycountry?.map((country) => ({
      value: country?.id,
      label: country?.country,
    })) || [];
  }, [props?.regulatorycountry]);

  return (
    <div className={styles.header}>
      <div>
        <div className={styles.orglabel}>Select Country <Asterisk /></div>
        <CustomDropdownMenu
          header={"List of Countries"}
          options={dropdownOptions}
          selectedValue={selectedOption}
          customheight={"customcss"}
          placeholder="Search by Country..."
          quickSerach={true}
          onSelect={(option) => setCountry(option)}
          renderTrigger={(isOpen) => (
            <div className={styles.inputWrapper}>
              <input
                type="text"
                value={selectedOption?.label || ""}
                readOnly
                className={styles.inputField}
                placeholder="Choose a country"
              />
              <img
                src={IMAGES.arrowdown}
                alt="Dropdown arrow"
                className={`${styles.arrows} ${isOpen ? styles.rotateArrow : styles.open}`}
              />
            </div>
          )}
        />
      {props?.UserType !== "internal" && props.showConsentPopup === true && (
          <RegulatoryDisclaimer  onAccept={onConsentAccept} loader ={props.loader}  setShowConsentPopup={props.setShowConsentPopup} /> 
      )}
        <div className={styles.note}>You can choose only one country at a time</div>
      </div>
    </div>
  )
}

const RegulatoryList = ({ protectedDivRef,regulatoryinfo ,UserType ,isUserConsentGiven,setShowConsentPopup,showConsentPopup,selectedCountry}) => {
  const DETAILS = regulatoryinfo?.data?.data?.details || {};
  const heightClasses = [styles.medium, styles.short, styles.short, styles.tall];

  const SUMMARY_FIELDS = ["Summary"];
  const STATUS_FIELDS = [
    "STIR/SHAKEN",
    "DNO",
    "KYC and CLI verification",
    "DNC",
    "Call Blocking and Filtering obligation",
    "International calls restriction"
  ];
  const visibleFields = STATUS_FIELDS?.filter((key) => DETAILS[key] !== undefined);

  return (
    <div className={styles.listwrapper}>
      {regulatoryinfo?.data?.data && !regulatoryinfo.loading ? (
        <div  ref={protectedDivRef} className={`${styles.listmain} ${styles.noselect}`}>
          <div className={styles.listhead}>
            <div className={styles.headlabel}>{DETAILS["Country"]}</div>
            {/* <div>
              <span className={styles.lastupdate}>
                <img className={styles.retry} src={IMAGES.retry} />
                Last Updated: {formatDate(regulatoryinfo?.data?.data?.modifiedAt)}</span>
              {UserType === "internal" &&<span className={styles.viewinfolink}><span className={styles.viewinfo}>View All Information</span></span>}
            </div> */}
          </div>
          <div className={styles.listinfo}>
            <span className={styles.listlabel}>Laws and Regulatory Basis: </span>
            <span className={styles.listvalue}>
              {DETAILS["Laws and Regulatory Basis"]?.split('\n').map((line, index) => (
                <React.Fragment key={index}>
                  {line}
                  <br />
                </React.Fragment>
              ))}
            </span>
          </div>
          {SUMMARY_FIELDS.filter((key) => DETAILS[key] !== undefined).map((key) => (
            <div className={styles.listinfo} key={key}><>
              <span className={styles.listlabel}>{key}: </span>
              <span className={styles.listvalue}>
                {DETAILS[key].split('\n').map((line, index) => (
                  <React.Fragment key={index}>
                    {line}
                    <br />
                  </React.Fragment>
                ))}
              </span></>
            </div>
          ))}
       {visibleFields.length > 0 && (
          <div className={styles.commonhead}>
            {STATUS_FIELDS?.filter((key) => DETAILS[key] !== undefined)?.map((key) => {
              const value = DETAILS[key];
              const isYesNo = value?.toLowerCase().startsWith("yes") || value?.toLowerCase().startsWith("no");
              // const formattedValue = isYesNo ? value.charAt(0).toUpperCase() + value.slice(1).toLowerCase(): value;
              const formattedValue = value == null || String(value).trim().toUpperCase() === 'TBC'  ? '---'
                    : isYesNo ? String(value).charAt(0).toUpperCase() + String(value).slice(1).toLowerCase() : value;
              return (
                <div className={styles.commonlist} key={key}><>
                  <div className={styles.infocontainer}>
                    <span className={styles.listlabel}>{key}</span>
                  </div>
                  <div className={styles.statusinfo}>
                    {isYesNo && (<img className={styles.statusIcon}
                      src={value?.toLowerCase().startsWith("yes") ? IMAGES.rightIcon : IMAGES.crossIcon} />)}
                    {formattedValue ? formattedValue : "---"}
                  </div></>
                </div>
              );
            })}
          </div>)}
           </div>
      ) : regulatoryinfo?.loading ?
        heightClasses?.map((heightClass, index) => (
          <div key={index} className={`${styles.loading} ${heightClass}`}><Shimmer /></div>))
        : (
          <div className={styles.globe}>
            <img className={styles.globeimg} src={IMAGES.globe} />
            <div className={styles.nodatatext}>{(!isUserConsentGiven && selectedCountry) || showConsentPopup ? <span>To view the regulations, please provide your consent <span className={styles.clickhere} onClick={()=>setShowConsentPopup(true)}>click here</span></span> :"Country Not Selected"}</div>
          </div>
        )}
    </div>
  );
}

const RegulatoryViewer = (props) => {
  const [isSelectedCountry, setIsSelectedCountry] = useState(null);
  const [showConsentPopup,setShowConsentPopup] = useState(false);
  const [loader, setShowloader] = useState(false);
  const [isUserConsentGiven, setIsUserConsentGiven] = useState(false); 
  const protectedDivRef = useRef(null)

  useRestrictCopyPaste({
    onAction: (type) => {
      // props.openAlertPopup({
      //   message: "The advertised data is Vodafone's interpretation of regulatory guidelines from different countries, and associated reference is provided alongside. Voice calls handling into Vodafone platform are based on this interpretation. In case customers have a different interpretation for a specific section, they should contact Vodafone. This data cannot be used for any other purpose. Copy/download/forwarding of data is not allowed.",
      //   image: IMAGES.error
      // }); // Pass the Redux action with parameter
         props.showErrorPopup(
           {errorHeader: ""},
           {errorMessage: "The advertised data is Vodafone interpretation of regulatory guidelines from different countries, and associated reference is provided alongside. Voice calls handling into Vodafone platform are based on this interpretation. In case customer have different interpretation for specific section, they should contact Vodafone. This data cannot be used for any other purpose. Copy/download/forwarding of data is not allowed."}
         );
    },
    targetRef: protectedDivRef,
  });

  const handleConsentAccept = async ()=>{
    try {
      setShowloader(true)
      await props.userConsent();
      setShowConsentPopup(false) 
      setIsUserConsentGiven(true)
      await props.getRegulatoryinfo(isSelectedCountry?.value);
    } catch (error) {
      console.log("error",error);
      setIsUserConsentGiven(false)
    } finally {
      setShowloader(false);
    }
  }

  const handleCountrySelect = async(option) => { 
     setIsSelectedCountry(option);
    if (!option) return;
    try {
      const res = await props.getRegulatoryinfo(option.value);
      if(res.code === "USER_CONSENT_REQUIRED"){
        setShowConsentPopup(true);
        setIsUserConsentGiven(false)
      }
    } catch (error) {
      console.log("error",error);
    }
  }

  useEffect(() => {
    props.getRegulatoryCountry();
    return () => {
      props.resetRegulatoryInfo();
    };
  }, [])

  useEffect(()=>{
    if(!props.isCustomErrorOpen){
      window.getSelection().removeAllRanges();
    }
  },[props.isCustomErrorOpen])

  return (
    <Container>
      <Banner image={IMAGES.vfbanner} text="Regulatory"/>
      <ChildContainer>
        <div className={styles.info}><img className={styles.circleinfo} src={IMAGES.infoCircle} /><span>Access telecommunications compliance requirements and regulatory frameworks by country.</span></div>
        <div className={`${styles.wrapperchild}`} >
            <CountryDropdown handleCountrySelect={handleCountrySelect} setIsUserConsentGiven={setIsUserConsentGiven} setShowConsentPopup={setShowConsentPopup} handleConsentAccept={handleConsentAccept} showConsentPopup={showConsentPopup} regulatorycountry={props.regulatorycountry} UserType={props.myRights?.userType} loader={loader}/>
            <RegulatoryList protectedDivRef={protectedDivRef} regulatoryinfo={props?.regulatory} UserType={props.myRights?.userType} isUserConsentGiven={isUserConsentGiven} setShowConsentPopup={setShowConsentPopup} showConsentPopup={showConsentPopup} selectedCountry={isSelectedCountry?.value}/>
        </div>
      </ChildContainer>
    </Container>
  )
};

export default RegulatoryViewer;

